import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-block d-md-none col-12" }
const _hoisted_2 = { class: "d-flex border-bottom border-bottom-2 border-bottom-primary pb-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chevron-left fs-2 pe-4 p-1" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", { class: "m-auto" }, "Measurements", -1)
const _hoisted_6 = {
  class: "d-flex ms-auto",
  style: {"flex":"1"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_MeasurementSettings = _resolveComponent("MeasurementSettings")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "cursor-pointer",
        style: {"flex":"1"},
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
      }, _hoisted_4),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_Button, {
          class: "btn-sm ms-auto",
          onClick: _ctx.saveMeasurements
        }, {
          default: _withCtx(() => [
            _createTextVNode("save")
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _createVNode(_component_MeasurementSettings)
  ]))
}